import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Subscription } from 'rxjs';
import { TicketActionService, TicketsInstructionService } from 'src/app/services';

@Component({
  selector: 'app-flights-tickets',
  templateUrl: './flights-tickets.component.html',
  styleUrls: ['./flights-tickets.component.scss']
})
export class FlightsTicketsComponent implements OnInit, OnDestroy {
  // @ViewChild('ticketRef') ticketRef!: ElementRef;
  @ViewChild('ticketRef', { static: true }) ticketRef!: ElementRef;
  @Input() isFlightInfo: any;
  private actionSub!: Subscription;
  currentDate = new Date().toLocaleString('en-GB', { hour12: false }).replace(',', '');
  constructor(public instruction: TicketsInstructionService, private ticketAction: TicketActionService) { }

  getTicketElement(): HTMLElement {
    return this.ticketRef?.nativeElement;
  }

  ngOnInit(): void {
    this.actionSub = this.ticketAction.action$.subscribe(data => {
      this.isFlightInfo = data;
      this.downloadOrPrintTicket(data);
    });
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  downloadOrPrintTicket(data: any): void {
    const action = data?.Action;
    this.isFlightInfo = data?.Flight;
    const ticketElement = this.ticketRef.nativeElement;
    const backButton = document.querySelector('.hideButton');

    if (!ticketElement) return console.error('Ticket element not found');

    // Create dynamic header
    const dynamicHeader = document.createElement('div');
    document.body.appendChild(dynamicHeader);
    backButton?.classList.add('no-print');

    html2canvas(dynamicHeader, {
      scale: 2,
      useCORS: true,
      allowTaint: true,
      logging: false
    }).then(headerCanvas => {
      const headerImgData = headerCanvas.toDataURL('image/jpeg', 0.8);
      html2canvas(ticketElement, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: false
      }).then(ticketCanvas => {
        const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });

        const marginX = 8;
        const marginTop = 0;
        const marginBottom = 30;

        const pageWidth = pdf.internal.pageSize.width - marginX * 2;
        const pageHeight = pdf.internal.pageSize.height - marginTop - marginBottom;

        const headerHeight = 8; // height of header image
        const contentHeightPx = Math.floor(ticketCanvas.width * (pageHeight / pageWidth));
        let renderedHeight = 0;

        const pageCanvas = document.createElement('canvas');
        const pageCtx = pageCanvas.getContext('2d')!;
        pageCanvas.width = ticketCanvas.width;

        while (renderedHeight < ticketCanvas.height) {
          const sliceHeight = Math.min(contentHeightPx, ticketCanvas.height - renderedHeight);
          pageCanvas.height = sliceHeight;
          pageCtx.clearRect(0, 0, pageCanvas.width, sliceHeight);
          pageCtx.drawImage(
            ticketCanvas,
            0, renderedHeight, ticketCanvas.width, sliceHeight,
            0, 0, ticketCanvas.width, sliceHeight
          ); 
          const slicedImageData = pageCanvas.toDataURL('image/jpeg', 1.0);
          const finalImageHeight = (sliceHeight * pageWidth) / ticketCanvas.width;

          // 🖼️ Add header
          pdf.addImage(headerImgData, 'JPEG', marginX, marginTop, pageWidth, headerHeight);
          pdf.addImage(
            slicedImageData,
            'JPEG',
            marginX,
            marginTop + headerHeight + 1,
            pageWidth,
            finalImageHeight
          );
          // 📄 Footer at the bottom
          const footerText = `Powered by Belairtrip.com | All Rights Reserved | ${new Date().toLocaleString('en-IN', {
            day: '2-digit', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
          })}`;
          pdf.setFontSize(8);
          pdf.text(footerText, marginX, pdf.internal.pageSize.height - 4); 
          renderedHeight += sliceHeight;
          if (renderedHeight < ticketCanvas.height) {
            pdf.addPage();
          }
        }

        // 🖨️ Print or 💾 Download
        if (action === 'download') {
          pdf.save('Belairtrip.com.pdf');
        } else if (action === 'print') {
          const pdfBlob = pdf.output('blob');
          const iframe = document.createElement('iframe');
          iframe.style.display = 'none';
          iframe.src = URL.createObjectURL(pdfBlob);
          document.body.appendChild(iframe);
          iframe.contentWindow?.print();
        }
      });
    }).finally(() => {
      backButton?.classList.remove('no-print');
      dynamicHeader.remove();
    });
  }

  hasAnyAncillaries(): boolean {
    return this.isFlightInfo?.segments?.some(segment =>
      segment?.passengers?.some(passenger =>
        passenger?.ancillaries && Object.keys(passenger.ancillaries).length > 0
      )
    );
  }
  ngOnDestroy() {
    this.actionSub?.unsubscribe();
  }
}
